import classNames from 'classnames';
import PropTypes from 'prop-types';
import UiSvg from '../UiSvg';
import styles from './style.m.less';

interface Props {
    isSpinning?: boolean;
    className?: string;
}
function Spinner({ isSpinning = true, className, ...other }: Props) {
    const spinnerClasses = classNames(styles.container, className);
    return isSpinning ? <UiSvg className={spinnerClasses} name="loading-spinner" {...other} /> : <noscript />;
}

Spinner.propTypes = {
    isSpinning: PropTypes.bool,
};

export default Spinner;
